"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _material = require("@mui/material");

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _zxcvbn = _interopRequireDefault(require("zxcvbn"));

var _styles = require("@mui/material/styles");

var _colors = require("../../colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var StrengthMeterGrid = (0, _styles.styled)(_material.Grid)(function (_ref) {
  var theme = _ref.theme;
  return {
    position: 'relative',
    height: '8px',
    background: _colors.GREY9,
    margin: '7px 0',
    borderRadius: '4px',
    '&::after, &::before': {
      content: '""',
      height: 'inherit',
      background: 'transparent',
      display: 'block',
      borderColor: theme.palette.background.default,
      borderStyle: 'solid',
      borderWidth: '0 6px 0',
      position: 'absolute',
      width: 'calc(20% + 6px)',
      zIndex: '10'
    },
    '&::after': {
      right: 'calc(20% - 3px)'
    },
    '&::before': {
      left: 'calc(20% - 3px)'
    }
  };
});
var StrengthMeterFillGrid = (0, _styles.styled)(_material.Grid)(function () {
  return {
    background: 'transparent',
    height: 'inherit',
    position: 'absolute',
    width: '0',
    borderRadius: 'inherit',
    transition: 'width 0.5s ease-in-out, background 0.25s',
    '&[data-strength="0"]': {
      width: '20%',
      background: _colors.RED1
    },
    '&[data-strength="1"]': {
      width: '40%',
      background: _colors.ORANGE2
    },
    '&[data-strength="2"]': {
      width: '60%',
      background: _colors.YELLOW2
    },
    '&[data-strength="3"]': {
      width: '80%',
      background: _colors.GREEN1
    },
    '&[data-strength="4"]': {
      width: '100%',
      background: _colors.GREEN2
    }
  };
});
var PasswordDescriptionBox = (0, _styles.styled)(_material.Grid)(function () {
  return {
    backgroundColor: _colors.YELLOW3,
    padding: '12px',
    marginTop: '12px',
    color: _colors.GREY10,
    borderRadius: '4px'
  };
});

var PasswordStrengthHelper = function PasswordStrengthHelper(_ref2) {
  var password = _ref2.password;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useState = (0, _react.useState)(-1),
      _useState2 = _slicedToArray(_useState, 2),
      strength = _useState2[0],
      setStrength = _useState2[1];

  (0, _react.useEffect)(function () {
    setStrength(password.length > 0 ? (0, _zxcvbn.default)(password).score : -1);
  }, [password]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: {
      marginTop: '8px',
      display: 'flex'
    }
  }, t('password_strength'), ":", password.length > 0 && (strength < 4 ? /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: {
      color: _colors.ORANGE3,
      marginLeft: '5px'
    }
  }, t('password_weak')) : /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: {
      color: _colors.GREEN2,
      marginLeft: '5px'
    }
  }, t('password_strong')))), /*#__PURE__*/_react.default.createElement(StrengthMeterGrid, null, /*#__PURE__*/_react.default.createElement(StrengthMeterFillGrid, {
    "data-strength": strength
  })), /*#__PURE__*/_react.default.createElement(PasswordDescriptionBox, null, t('password_strength_description')));
};

PasswordStrengthHelper.propTypes = {
  password: _propTypes.default.string.isRequired
};
var _default = PasswordStrengthHelper;
exports.default = _default;